import React, { useState } from 'react';
import { FaTimes } from 'react-icons/fa';

const FeedbackModal = ({ isOpen, onClose, onSubmit, isDarkMode }) => {
    const [selectedTags, setSelectedTags] = useState([]);
    const [details, setDetails] = useState("");

    const tags = [
        "Shouldn't have used Memory", "Don't like the personality",
        "Don't like the style", "Not factually correct",
        "Didn't fully follow instructions", "Refused when it shouldn't have",
        "Being lazy", "Unsafe or problematic",
        "Biased", "Other"
    ];

    const handleTagClick = (tag) => {
        setSelectedTags(prev =>
            prev.includes(tag) ? prev.filter(t => t !== tag) : [...prev, tag]
        );
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Combine tags and details
        let feedback = selectedTags.join(", ");
        if (details) {
            feedback = feedback ? `${feedback}. ${details}` : details;
        }
        onSubmit(feedback || "Negative feedback"); // Ensure some text handles empty submission if allowed

        // Reset and close
        setSelectedTags([]);
        setDetails("");
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div
                className={`w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden ${isDarkMode ? "bg-gray-800 text-gray-100" : "bg-white text-gray-900"
                    } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
                {/* Header */}
                <div className={`flex items-center justify-between p-4 border-b ${isDarkMode ? "border-gray-700" : "border-gray-100"}`}>
                    <h3 className="text-lg font-semibold">Share feedback</h3>
                    <button
                        onClick={onClose}
                        className={`p-2 rounded-full transition-colors ${isDarkMode ? "hover:bg-gray-700 text-gray-400 hover:text-white" : "hover:bg-gray-100 text-gray-500 hover:text-gray-900"
                            }`}
                    >
                        <FaTimes />
                    </button>
                </div>

                {/* Body */}
                <div className="p-6 space-y-4">
                    <div className="flex flex-wrap gap-2 mb-4">
                        {tags.map((tag) => (
                            <button
                                key={tag}
                                onClick={() => handleTagClick(tag)}
                                className={`px-3 py-1.5 rounded-lg text-sm transition-all border ${selectedTags.includes(tag)
                                        ? isDarkMode
                                            ? "bg-cyan-600/20 border-cyan-500 text-cyan-400"
                                            : "bg-cyan-50 border-cyan-500 text-cyan-700"
                                        : isDarkMode
                                            ? "bg-gray-700/50 border-gray-600 text-gray-300 hover:bg-gray-700"
                                            : "bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100"
                                    }`}
                            >
                                {tag}
                            </button>
                        ))}
                    </div>

                    <textarea
                        value={details}
                        onChange={(e) => setDetails(e.target.value)}
                        placeholder="Share details (optional)"
                        className={`w-full p-3 rounded-xl resize-none h-24 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500 ${isDarkMode
                                ? "bg-gray-900 border-gray-700 placeholder-gray-500 text-white"
                                : "bg-gray-50 border-gray-200 placeholder-gray-400 text-gray-900"
                            } border`}
                    />

                    <div className={`text-xs p-3 rounded-lg ${isDarkMode ? "bg-gray-700/50 text-gray-400" : "bg-gray-50 text-gray-500"}`}>
                        Submitting feedback will help improve the model.
                    </div>
                </div>

                {/* Footer */}
                <div className={`p-4 border-t flex justify-end ${isDarkMode ? "border-gray-700" : "border-gray-100"}`}>
                    <button
                        onClick={handleSubmit}
                        className={`px-6 py-2 rounded-lg font-medium transition-transform active:scale-95 ${(selectedTags.length > 0 || details.trim().length > 0)
                                ? "bg-cyan-500 hover:bg-cyan-600 text-white shadow-lg shadow-cyan-500/25"
                                : isDarkMode ? "bg-gray-700 text-gray-500 cursor-not-allowed" : "bg-gray-200 text-gray-400 cursor-not-allowed"
                            }`}
                        disabled={!selectedTags.length && !details.trim()}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FeedbackModal;
